<div class="card block isMinimizable"
     [stepContent]="chargeStepContent"
     joyrideStep="chargeStep">
    <div class="card-header">
        <div class="card-title">
            <h6>Total des charges mensuelles
                <p class="value">{{ favorite.charge | number:'1.0-0' }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Charges</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_charges.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <h3 class="mt-0">Gestion locative</h3>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Gestion en agence<i class="fa fa-info-circle"
                                                   matTooltip="Le taux moyen pour une gestion locative en agence est de 7%."></i>
                    </mat-label>
                    <input type="number" step="0.5" matInput [(ngModel)]="favorite.agence"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Frais de relocation par agence<i class="fa fa-info-circle" matTooltip="Lorsque vous avez un changement de locataire, l’agence immobilière va facturer des frais pour faire les visites et les états des lieux.
Ces frais correspondent en moyenne à 1 mois de loyer charges comprises."></i></mat-label>
                    <input type="number" step="0.5" matInput [(ngModel)]="favorite.agence_rental"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <h3>Assurances</h3>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Garantie loyers impayés<i class="fa fa-info-circle"
                                                         matTooltip="Le coût d’une Garantie Loyers Impayés (GLI) est en moyenne de 3%."></i>
                    </mat-label>
                    <input type="number" step="0.5" matInput [(ngModel)]="favorite.amount_rent_insurance"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Assurance PNO<i class="fa fa-info-circle"
                                               matTooltip="L’assurance PNO (Propriétaire Non Occupant) vous couvre en cas de dégradations qui ne seraient pas prises en charges par l’assurance habitation de votre locataire."></i>
                    </mat-label>
                    <input type="number" step="10" matInput [(ngModel)]="favorite.building_insurance" (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <h3>Charges courantes</h3>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Taxe foncière <i class="fa fa-info-circle" matTooltip="Indiquez ici le montant de la taxe foncière sans la Taxe d’Enlèvement des Ordures Ménagères (TEOM). La TEOM est récupérable dans les charges de votre locataire et doit être renseignée dans la case “Charges de copro (part locataire)”.
Par défaut, nous mettons la taxe foncière correspond à 1 mois de loyer."></i></mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_property_tax"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Vacance locative<i class="fa fa-info-circle"
                                                  matTooltip="Le nombre de mois ou votre logement sera vide chaque année (peut arriver entre 2 locataires par exemple). Dans le cas d’un immeuble, cela s’applique à chacun des lots."></i>
                    </mat-label>
                    <input type="number" step="0.5" matInput [(ngModel)]="favorite.rental_vacancy"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>mois/an</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Charges de copro (part propriétaire)
                        <i class="fa fa-info-circle"
                           matTooltip="Montant des charges non récupérables. La liste officielle des charges récupérables sur votre locataire est disponible ici : https://www.economie.gouv.fr/particuliers/proprietaire-bailleur-charges-recuperables-locataire"></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_copro"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Autres frais<i class="fa fa-info-circle"
                                              matTooltip="Entretien, provision pour travaux, charges non prévues ..."></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.other_bill" (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <h3>Frais de comptabilité</h3>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Comptable</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.accouting_fees" (ngModelChange)="edit($event)">
                    <span matSuffix> €/an</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>CFE</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.cfe_contribution" (ngModelChange)="edit($event)">
                    <span matSuffix> €/an</span>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>

<ng-template #chargeStepContent>
    <div class="user_onboarding_content">
        <h2>Les charges de votre projet</h2>
        <p>
            C’est ici que l’on parle des choses qui fâchent : <b>vos charges en tant que propriétaire</b> !<br/>
            <br/>
            Renseignez tout ce que vous allez devoir payer : gestion en agence, charges de copropriété,
            assurances, taxe foncière, comptabilité…<br/>
            <br/>
            Ces éléments permettent de calculer le <b>rendement locatif net</b> de votre projet.
        </p>
    </div>
</ng-template>
